import z from 'zod';

export const baseSchema = z.object({
  name: z.string().min(1, 'The company name is required'),
  contactNumber: z.string().min(1, 'The phone number is required')
});

export const createCompanySchema = baseSchema;
export const updateCompanySchema = baseSchema;

export const parseCompanySchema = (parsedData: any) => {
  const errors: { [k: string]: string } = {};
  parsedData.error.errors.forEach(
    (e: { path: { toString: () => string | number }[]; message: string }) => {
      if (e.path[0]) errors[e.path[0].toString()] = e.message;
    }
  );
  return errors;
};
